import React from 'react';

const EricCarleDisney = ({ width, fillColor="#DADADA" }) => {
	return (
		<div
			id='eric-carle-disney'
			className={`eric-carle-disney-icon flex justify-center items-center h-auto`}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width={width}
				height='78'
				fill='none'
				viewBox='0 0 75 78'
			>
				<g clipPath='url(#clip0_4077_842)'>
					<path
						fill='#414042'
						d='M2.603 15.645H1.72v-.368h3.66v.368h-.953l1.187 3.436h.027l1.296-3.436h-.957v-.368h3.774v.368h-.959L9.96 19.08h.025l1.249-3.436h-.879v-.368h2.226v.368h-.882l-2.205 5.773h-.387l-1.961-5.264-2.019 5.264H4.76zM17.2 18.274c0 1.433 0 2.778-1.275 2.778s-1.27-1.344-1.27-2.778 0-2.778 1.27-2.778 1.275 1.347 1.275 2.778m1.908 0c0-1.812-1.308-3.146-3.183-3.146s-3.183 1.334-3.183 3.146c0 1.922 1.286 3.144 3.183 3.144 1.875 0 3.183-1.333 3.183-3.144M19.94 20.903h.884v-5.259h-.883v-.367h.762c.619 0 1.257-.027 1.883-.075v.988h.023a1.68 1.68 0 0 1 1.546-1.062c.77 0 1.173.536 1.173 1.236 0 .501-.244.82-.796.82-.479 0-.748-.245-.748-.648 0-.357.025-.393.025-.574 0-.148-.06-.245-.234-.245-.708 0-.989 1.653-.989 2.603v2.582h.883v.371H19.94v-.371M25.836 20.903h.88v-8.016h-.88v-.366h.757c.626 0 1.265-.022 1.885-.076v8.458h.883v.371h-3.525zM34.7 18.274c0 1.164-.088 2.629-1.373 2.629-.943 0-1.273-.856-1.273-2.63 0-1.455.058-2.629 1.273-2.629 1.285 0 1.373 1.636 1.373 2.63m-.04 3.069c.736-.048 1.445-.057 2.641-.069v-.371h-.878v-8.458c-.623.054-1.261.076-1.883.076h-.76v.366h.88v3.122h-.023c-.283-.61-.932-.88-1.7-.88-1.803 0-2.743 1.492-2.743 3.145 0 1.7.78 3.144 2.64 3.144.665 0 1.362-.132 1.803-.855h.024zM62.273 18.424c0 1.433 0 2.778-1.274 2.778-1.273 0-1.273-1.345-1.273-2.778s0-2.778 1.273-2.778c1.274 0 1.274 1.347 1.274 2.778m1.909 0c0-1.812-1.308-3.146-3.183-3.146s-3.182 1.334-3.182 3.146c0 1.922 1.287 3.144 3.182 3.144 1.875 0 3.183-1.333 3.183-3.144M65.149 21.053h.882v-5.258h-.882v-.368h.882v-.75c0-1.306.684-2.15 2.448-2.15.562 0 1.98.208 1.98 1.316 0 .6-.28.862-.755.862-.624 0-.783-.346-.783-.787 0-.488 0-1.026-.526-1.026-.537 0-.6.452-.6.915v1.62h1.013v.367h-1.013v5.259h1.013v.371H65.15z'
					></path>
					<path
						fill={fillColor}
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='M18.812 30.55v-5.573l-16.995.22v24.279h17.712l-.773-6.07-11.2.11.165-4.019h9.05l.11-4.92-6.953-.496.166-3.587zM21.26 24.643v25.29h7.401V39.497l7.563 10.435 6.008-2.899-6.662-9.807 3.023-2.036 1.295-2.405.062-3.393-1.357-2.344-3.208-1.604-3.64-.801z'
					></path>
					<path
						fill='#fff'
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='m29.361 29.145-.33 6.23 3.332-.37 1.727-1.727.61-1.85-.953-1.79-1.57-.493z'
					></path>
					<path
						fill={fillColor}
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='M33.937 52.458v25.29h5.74V67.313l5.867 10.435 4.66-2.9-5.168-9.806 2.345-2.036 1.005-2.406.047-3.392-1.052-2.344-2.488-1.604-2.823-.802z'
					></path>
					<path
						fill='#fff'
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='m40.22 56.96-.255 6.23 2.583-.369 1.34-1.727.473-1.85-.738-1.79-1.218-.493z'
					></path>
					<path
						fill={fillColor}
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='M43.404 30.934h8.45l.494 18.542h-8.944zM54.258 22.994l-.837 2.09-1.02 2.301-1.573 1.76-1.17.624H45.7l-1.9-1.422-1.336-1.631-1.296-4.173-.418-4.046.585-2.853 1.338-2.729.73-.753 2.114-1.045 2.76-.46 1.422.502 2.343 1.547 1.547 2.05.962 2.104.292 2.663z'
					></path>
					<path
						fill='#fff'
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='m48.507 23.178-.282-.634h-.599l-.176.634-.317.598-.176.529.775.282h.528l.775-.141v-.564zM50.603 15.412h-.796l-.593.266-.286.45-.265 1.02v2.37l.372 1.385.302.679.776.429h.654l.409-.389.898-1.634.327-2.635-.224-.94-.41-.47zM46.743 15.636l-.409-.357-.674-.092-.777.225-.306.347-.225.51-.286.94-.265 1.594v1.9409999999999998l.306.674.511.204.838.184.694-.123.715-.265.49-.777.245-1.327-.122-1.492-.245-1.185z'
					></path>
					<path
						fill={fillColor}
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='m49.7 10.666.832-3.053.338-2.551.419-1.84.376-2.384-.544-.627-.59.25-.832.503-.502 1.84v6.691000000000001l.168 1.17zM45.517 10.807l.693-.116.097-2.389-.395-2.535-.395-2.718-.147-.96-.525-.981-.411-.206h-.64l-.525.388.114 1.28.32 1.827 1.256 2.877zM70.46 33.772l-1.096-.638-2.377-.874-2.494.756-1.856.756-1.334 1.603-.696 3.152.754 3.596L63.45 44.5l2.085.463 2.729-.87 2.197-1.391 3.776 4.697-1.102 1.45-3.538 1.566-4.523.29-3.886-.774-4.001-1.836-2.343-4.06-1.253-4.87.348-4.988 1.566-3.712 2.378-3.015 2.784-1.624 2.203-.928 3.074-.256 4.233.604 2.958 1.392 1.45 1.913zM14.917 60.814l-.957-.638-2.078-.873-2.179.756-1.621.755-1.166 1.604-.608 3.152.659 3.595 1.824 2.378 1.822.464 2.384-.87 1.92-1.392 3.3 4.698-.963 1.45-3.091 1.565-3.953.29-3.395-.773-3.497-1.836-2.047-4.06-1.095-4.871.304-4.988 1.368-3.711 2.078-3.016L6.36 52.87l1.925-.928 2.686-.256 3.7.604 2.584 1.392 1.267 1.914zM50.917 77.047h10.898v-6.073h-4.988l.054-5.15.271-8.863v-4.8l-6.614.297zM74.339 77.047h-11.44V52.458h11.685v4.745l-6.588.109.162 4.554 5.53-.325.217 4.88-5.584.216-.163 5.042 6.18-.488zM22.996 76.938h-4.988l3.145-24.48 9.27.245 2.82 24.235h-5.585l-1.047-7.024-2.585.138z'
					></path>
					<path
						fill='#fff'
						stroke='#414042'
						strokeMiterlimit='10'
						strokeWidth='0.35'
						d='m23.7 66.039 2.82.436-.434-8.35h-1.68z'
					></path>
				</g>
				<defs>
					<clipPath id='clip0_4077_842'>
						<path fill='#fff' d='M0 0h74.805v77.993H0z'></path>
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export default EricCarleDisney;
